export const getAlerts = state => state.alerts.queue;
export const getQueueLength = state => state.alerts.queue.length;
export const getCurrentAlert = state => state.alerts.queue[0];
export const getIsQueueRunning = state => state.alerts.queueRunning;
